import {useState} from 'react'
import './App.css'
import { QRCodeSVG } from 'qrcode.react'
import {startIdentityVerification} from './client-api'
import { sleep } from './sleep'

function App() {
  const [element, setElement] = useState(<div>Waiting...</div>)
  const [done, setDone] = useState(true)
  
  const verify = async () => {
    console.log("Called verify");
    setDone(false)
    try {
      const verifierUrl = "/api"
      setElement(<div>Verifying Identity...</div>)
      const verificationTask = await startIdentityVerification(verifierUrl, {headers: {"ollet-claims": 'Surname,GivenNames'}})
      console.log('olletUrlString: ', verificationTask.olletUrlString)
      setElement(<QRCodeSVG
                  value={verificationTask.olletUrlString}
                  size={256}
                  level="M"
                />)
      await verificationTask.verificationStarted()
      setElement(<div>Please complete verification in Ollet</div>)
      const result = await verificationTask.verificationResult()
      if (!result.ok) {
        const message = await result.text()
        setElement(<div>Failed: {message}</div>)
      } else {
        const resultJson = await result.json()
        const {
          surname,
          givenNames
        } = JSON.parse(resultJson) 
        setElement(<div>{givenNames} {surname}</div>)
      }
    } catch (error: unknown) {
      const reason = (typeof error === "string") ? error : 'unknown error'
      setElement(<div>Failed: {reason}</div>)
    }
    await sleep(15000)
    setDone(true)
  }

  return (
    <div className="card">
      {done ?
        <button onClick={verify}>
          Start Demo
        </button> : element
      }
    </div>
  )

}

declare global {
  interface Window {
    startIdentityVerification: unknown
  }
}

window.startIdentityVerification = startIdentityVerification

export default App
